import { AlertCircle, CheckCircle, Info, XCircle } from 'lucide-react';
import { FC, useState, useCallback, memo } from 'react';

import { AlertType } from '@utils/constants';

import * as Styled from './styled';

type Props = {
  type: AlertType;
  message: string;
  onClick: () => void;
};

const Alert: FC<Props> = ({ type, message, onClick }) => {
  const [isExiting, setIsExiting] = useState(false);

  const handleClick = useCallback(() => {
    setIsExiting(true);

    // Allow animation to complete
    const timeoutId = setTimeout(() => {
      onClick();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [onClick]);

  const getIcon = useCallback(() => {
    switch (type) {
      case AlertType.Error:
        return <XCircle size={16} />;
      case AlertType.Success:
        return <CheckCircle size={16} />;
      case AlertType.Warning:
        return <AlertCircle size={16} />;
      default:
        return <Info size={16} />;
    }
  }, [type]);

  return (
    <Styled.Container
      $variant={type}
      $isExiting={isExiting}
      onClick={handleClick}
      role='alert'
    >
      <Styled.IconWrapper $variant={type}>{getIcon()}</Styled.IconWrapper>
      <Styled.Message>{message}</Styled.Message>
    </Styled.Container>
  );
};

export default memo(Alert);
